import FirebaseController from '../controllers/FirebaseController'

/**
 * Auth related stuff abstracted from firebase
 */

export default {
	// Observer
	isLoggedIn(callback) {
		return FirebaseController.onSessionChanged(callback)
	},

	displayName() {
		return FirebaseController.user().displayName != null ?
			FirebaseController.user().displayName : FirebaseController.user().email
	},

	userImageUrl() {
		return FirebaseController.userProfilePicture()
	},

	userId() {
		return FirebaseController.user().uid
	},

	userEmail() {
		return FirebaseController.user().email
	},

	login(accountType) {
		return FirebaseController.signInWith(accountType)
	},

	loginWithEmail(email, password) {
		return FirebaseController.loginUserWithEmail(email, password)
	},

	registerUser(email, password) {
		return FirebaseController.registerNewUser(email, password)
	},

	logout() {
		return FirebaseController.signOut()
	}
}


// WEBPACK FOOTER //
// ./src/controllers/AuthController.js